export const PlaylistType = {
  Media: 0,
  PPT: 1,
  Webcam: 2,
};
